// Libs
import type React from "react";

// Api
import { useQueryAdminMonitoringGetOrganizationList } from "src/api/admin-monitoring";

// Components
import LoadingFrame from "src/components/LoadingFrame";
import { SideMenuLayout } from "../SideMenuLayout/SideMenuLayout";

// Utiles
import { useQuerySFUsers } from "src/api/sales-force";
import { SideMenuAdminMonitoring } from "src/views/admin/AdminView/admin-monitoring/SideMenuAdminMonitoring";
import { useSideMenuAdminMonitoringStyles } from "src/views/admin/AdminView/admin-monitoring/SideMenuAdminMonitoring.styles";

interface AdminMonitoringLayoutProps {
    children?: React.ReactNode;
}

export interface OrganizationSideMenu {
    title: string;
    href: string;
    ownerId?: string;
    id: number;
}

function AdminMonitoringLayout(props: AdminMonitoringLayoutProps): JSX.Element {
    const { data, status } = useQueryAdminMonitoringGetOrganizationList();
    const classes = useSideMenuAdminMonitoringStyles();
    const { data: SFUsers, status: statusSFUsers } = useQuerySFUsers();

    return (
        <LoadingFrame status={[status, statusSFUsers]}>
            <SideMenuLayout sections={[]} isAdmin classNameMenu={classes.menuContent}>
                <SideMenuAdminMonitoring
                    organizationWithErrorList={data?.organizationsWithError}
                    organizationWithAlertList={data?.organizationsWithAlert}
                    SFUsers={SFUsers}
                />
                {props.children}
            </SideMenuLayout>
        </LoadingFrame>
    );
}

export default AdminMonitoringLayout;
